<div class="list-page">
  <h2>Tilintarkastajat</h2>

  <div style="display: flex; justify-content: flex-end; flex-flow: row; align-items: center; margin-bottom: 10px">
    <app-primary-button (click)="lisaa()" actionId="Lisää uusi tilintarkastaja" additionalClass="mat-elevation-z4" matIcon="add"> Lisää tilintarkastaja </app-primary-button>
  </div>

  <mat-table [dataSource]="dataSource" matSort [matSortDisableClear]="true" style="min-height: 94px">
    <ng-container matColumnDef="aktiivinen">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Aktiivinen </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox [disabled]="true" [checked]="!row.poistettu"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="etunimi">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Etunimi</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="muokkaa(row)">{{ row.etunimi }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="sukunimi">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Sukunimi</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="muokkaa(row)">{{ row.sukunimi }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="muokkaa(row)">{{ row.email }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="tila">
      <mat-header-cell *matHeaderCellDef>Tila</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="muokkaa(row)">{{ TILINTARKASTAJAN_TILA_TEKSTI[row.tila] || 'Ei tilaa' }}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  @if (!loading() && dataSource?.filteredData?.length == 0) {
    <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
      <div style="width: 100%; padding-top: 40px; text-align: center">Yhtään tilintarkastajaa ei löytynyt.</div>
    </div>
  }
  <div lemon-loading [show]="loading()"></div>
</div>
